import { isAppleDevice, selfInstantiateOnLoad } from "../utils";
/**
 * Thin HTTP POST seam over the global fetch. Centralizes the eWallet network
 * boundary so it can be substituted in tests. Always issues a POST and forwards
 * any caller-provided headers/body verbatim to fetch.
 */
export function httpPost(url, init = {}) {
    return fetch(url, { method: "POST", ...init });
}
export class EWallet {
    constructor() {
        this.barcode = {};
        if (isAppleDevice()) {
            document.querySelectorAll(".passbookButton").forEach((button) => {
                button.style.display = "block";
            });
            document.querySelectorAll(".sendToAndroidPayButton").forEach((button) => {
                button.remove();
            });
        }
        else {
            document.querySelectorAll(".passbookButton").forEach((button) => {
                button.remove();
            });
            const androidButtons = document.querySelectorAll(".sendToAndroidPayButton");
            this.createAndroidPayButtons(androidButtons);
        }
    }
    async createAndroidPayButtons(buttons) {
        for (const iframeContainer of buttons) {
            const id = iframeContainer.id;
            const splitId = id.split("_");
            const specialId = splitId[2];
            const cookieName = "dealeron_coupon_claimer_" + splitId[1];
            let guid;
            const card = document.querySelector(`#specialDto-${specialId}`);
            const observer = new MutationObserver((mutations) => {
                setTimeout(() => {
                    this.updateIframeStyling(iframeContainer);
                }, 1000);
                observer.disconnect();
            });
            observer.observe(iframeContainer, {
                childList: true,
                subtree: true,
            });
            if (window.DealeronCookie.hasItem(cookieName)) {
                guid = window.DealeronCookie.getItem(cookieName);
            }
            else {
                guid = this.generateGuid();
                window.DealeronCookie.setItem(cookieName, guid, 90 * 24 * 60 * 60);
            }
            const specialDto = {
                SpecialId: specialId,
                Guid: guid,
                StartDate: card?.dataset?.startdate
                    ? this.toIsoString(card.dataset.startdate)
                    : "",
                ExpirationDate: card?.dataset?.expirationdate
                    ? this.toIsoString(card.dataset.expirationdate)
                    : "",
                Title: card?.dataset?.specialtitle ?? "",
                Description: card?.dataset?.description ?? "",
                Disclaimer: card?.dataset?.disclaimer ?? "",
            };
            try {
                const response = await httpPost(`/api/spclsab/ewallet/generateGoogleJwt?dealerId=${globalThis.DlronGlobal_DealerId}`, {
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                    },
                    body: JSON.stringify(specialDto),
                });
                if (response.ok) {
                    const responseData = await response.json();
                    const jwt = responseData.jwt;
                    this.barcode[specialId] = responseData.barcode;
                    window.gapi.savetoandroidpay.render(id, {
                        jwt: jwt,
                        onsuccess: this.successhandler.bind(this),
                        onfailure: this.failurehandler.bind(this),
                    });
                    this.setAriaLabel();
                }
            }
            catch (error) {
                console.error("Error generating Google JWT:", error);
            }
        }
    }
    toIsoString(dateString) {
        const date = new Date(dateString);
        return date.toISOString();
    }
    setAriaLabel() {
        const googlePayObserver = new ResizeObserver((entries, observer) => {
            entries.forEach((entry) => {
                const iframeElement = entry.target;
                if (!iframeElement.getAttribute("aria-label")) {
                    iframeElement.setAttribute("aria-label", "Send To Google Pay");
                    observer.unobserve(iframeElement);
                }
            });
        });
        const iFrames = document.querySelectorAll(".sendToAndroidPayButton iframe");
        iFrames.forEach((iFrame) => {
            googlePayObserver.observe(iFrame);
        });
    }
    updateIframeStyling(iframeContainerElement) {
        const iframeElement = iframeContainerElement.querySelector("iframe");
        if (!iframeElement)
            return;
        const frameHeight = iframeElement.style.height;
        const frameHeightCalc = `calc(${frameHeight}*1.2)`;
        iframeContainerElement.style.height = frameHeightCalc;
        iframeElement.style.height = frameHeightCalc;
        const frameWidth = iframeElement.style.width;
        const frameWidthCalc = `calc(${frameWidth}*1.2)`;
        iframeContainerElement.style.width = frameWidthCalc;
        iframeElement.style.width = frameWidthCalc;
        iframeContainerElement.classList.add("addMargin");
        iframeContainerElement.style.opacity = "1";
    }
    generateGuid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = (crypto.getRandomValues(new Uint8Array(1))[0] & 0x0f) | 0x00;
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    dispatchDoTaggingEvent(specialId) {
        const offerElement = document.getElementById("special--" + specialId);
        const offerName = offerElement?.querySelector("h1, h2, h3, h4, h5, h6")?.textContent || "";
        const eventData = {
            card_name: offerName,
            element_color: "#00",
            element_order: offerElement?.dataset.specialOrder || "",
            element_position: "unknown",
            element_state: "",
            element_subtype: "cta-button",
            element_text: "Add to Google Wallet",
            element_title: offerName,
            element_type: "item_details",
            element_value: "",
            event: "cta_interaction",
            event_action: "click",
            event_action_result: "open",
            event_location: "body",
            event_owner: "dealeron",
            product_name: "Website|Specials",
            promotion_id: specialId || "",
            promotion_name: offerName,
            promotion_type: "",
        };
        window.dispatchEvent(new CustomEvent("dotagging.event", {
            bubbles: true,
            detail: {
                data: eventData,
            },
        }));
    }
    successhandler(params) {
        const objectData = params.walletObjectIds["0"].split(".")[1].split("_");
        const dealerId = objectData[0];
        const specialId = objectData[2];
        const objectId = objectData[3];
        const couponBarcode = this.barcode[specialId];
        const offerData = {
            dealerId: dealerId,
            specialId: specialId,
            objectId: objectId,
            barcode: couponBarcode,
        };
        this.dispatchDoTaggingEvent(specialId);
        httpPost("/api/spclsab/ewallet/postObjectUserID", {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(offerData),
        })
            .then((response) => response.text())
            .catch((error) => console.error("Error posting object user ID:", error));
    }
    failurehandler(params) {
        this.dispatchDoTaggingEvent(params?.walletObjectIds?.["0"]?.split(".")?.[1]?.split("_")?.[2]);
        httpPost(`/api/spclsab/ewallet/postGoogleJWTError?errorMessage=${params.errorMessage}&dealerId=${globalThis.DlronGlobal_DealerId}`).catch((error) => console.error("Error posting Google JWT error:", error));
    }
}
selfInstantiateOnLoad(EWallet);
